import React from 'react';
import ClassAssembly  from 'views/ClassAssembly8E';

const ClassAssemblyPage = () => {
    return <ClassAssembly />;
  };
  
  export default ClassAssemblyPage;